<template>
<form
  class="AuthorizerForm AuthorizerFormVerify"
  name="authorizer-verify"
  @submit.prevent="submit">

  <div class="AuthorizerForm__fieldset">
    <InputCode/>
  </div>

  <div class="AuthorizerForm__submit">
    <button type="submit" class="button">
      <span>Login</span>
    </button>
  </div>

  <div class="AuthorizerForm__bottom">
    <a>Send it again</a>
    <p>Be quick! Code expires in 12 hours</p>
  </div>

</form>
</template>

<script>
import InputCode from '@/components/input-code/InputCode.vue';
export default {
  name: 'AuthorizerVerify',
  components: {
    InputCode,
  },
  data() {
    return {
      codeValue: '',
    };
  },
  methods: {
    async submit() {
      const {codeValue: code} = this;
      console.log('VERIFY', code);
    },
  },
}
</script>